import { useMemo } from 'react';
import { useSubscription } from 'react-relay';
import type { GraphQLSubscriptionConfig } from 'relay-runtime';

import type {
  ChargeUpdatedStatusSubscription as ChargeUpdatedStatusSubscriptionType,
  ChargeUpdatedStatusSubscription$variables,
} from './__generated__/ChargeUpdatedStatusSubscription.graphql.ts';
import ChargeUpdatedStatus from './ChargeUpdatedStatusSubscription.ts';

const useChargeUpdateStatusSubscription = (
  variables: ChargeUpdatedStatusSubscription$variables,
): void => {
  const newChargeUpdatedStatus = useMemo<
    GraphQLSubscriptionConfig<ChargeUpdatedStatusSubscriptionType>
  >(
    () => ({
      subscription: ChargeUpdatedStatus,
      variables,
    }),
    [variables],
  );

  useSubscription(newChargeUpdatedStatus);
};

export { useChargeUpdateStatusSubscription };
